export const CHAT_MESSAGE_LABELS = {
  TYPE: 't',
  TOKENS: 'tk',
  TIP_TO_REACH_GOAL: 'tg',
  GIFT_ID: 'id',
  FANCLUB: 'fc',
  JOIN_FANCLUB: 'jfc',
  ANONYMOUS: 'a',
  ORIGINAL_USERNAME: 'ou',
  MESSAGE: 'm',
  ACCESS_LEVEL: 'l',
  IS_ROOM_MODERATOR: 'rm',
  MESSAGE_HASH: 'mh',
  GENDER: 'g',
  LANGUAGE: 'lg',
  GAME_RESULT: 'gr',
  VIDEO_TITLE: 'vt',
  VIDEO_PRICE: 'vp',
  VIDEO_COUNT: 'vc',
  GIFT_VALUE: 'gv',
  GIFT_IMAGE: 'gi',
  TIMESTAMP: 'tm',
  PROPERTIES: 'p',
  IS_BROADCASTING: 'b',
  GAME_NAME: 'gt',
  GAME_OPERATION: 'go',
  BOOST_VIEWERS: 'bv',
  BOOST_UNIQUE_VIEWERS: 'buv',
  IS_GIF_MESSAGE: 'gi',
  GIF_ID: 'gid',
  CURRENCY: 'cu',
  TENANT: 'pa',
};

export const USER_NOTIFICATION_STATE_LABELS = {
  PRIVATE_DIRECTORY_USER_NOTIFICATION: 'aps',
  PRIVATE_DIRECTORY_USER_NOTIFICATION_CHANGED: 'psc',
  PRIVATE_DIRECTORY_ROOM_OFFLINE: 'rwo',
  FRIEND_REQUEST_RECEIVED: 'frR',
  FRIEND_REQUEST_CANCELED: 'frC',
  FRIEND_REQUEST_ACCEPT: 'frA',
  FRIEND_DELETE: 'frD',
  FAVORITE_ADD: 'fvA',
  FAVORITE_REMOVE: 'fvR',
  TWITTER_CONNECT: 'twc',
  TWITTER_CONNECT_SUCCESS: 'scs',
  USER_JOINED_FANCLUB: 'fc',
};

export const WEB_USERS_ROOM_NOTIFICATION_LABELS = { STATUS: 's' };

export const WebUsersRoomNotificationValues = {
  PERMA_BANNED: 'pb',
  BANNED: 'b',
  KICKED: 'k',
  CLOSED_ROOM: 'cr',
  PS_ENDED_SPY_NO_FUNDS: 'ps_nf',
  PS_ENDED_SPY_NOT_ALLOWED: 'ps_na',
  PENDING: 'p',
};

export const WebUsersPresence = {
  ROOMNAME: 'r',
  PRESENCE: 'p',
};

export const ROSTER_LABELS = {
  USER_INFO: 'i',
  PRESENCE: 'p',
  STEALTH_LEVEL: 'a',
  ACCESS_LEVEL: 'l',
  GENDER: 'g',
  IS_BROADCASTING: 'br',
  IS_ROOM_MODERATOR: 'rm',
  IS_SILENCED: 's',
  ORIGINAL_USERNAME: 'ou',
  USER_ID: 'id',
  IS_FANCLUB_SUBSCRIBED: 'fc',
  NOTIFY_BROADCASTER: 'nb',
  VIEWER_TYPE: 'wt',
};

export const STEALTH_LEVEL = {
  VISIBLE: 0,
  USER_HIDDEN: 1,
  ANONYMOUS: 2,
};

export const FIREBASE_AUTH_STATUS = {
  bannedForRoom: 'bannedForRoom',
  alreadyInTheRoom: 'alreadyInTheRoom',
  privateRoom: 'privateRoom',
  userIsFromBlockedCountryOrRegion: 'userIsFromBlockedCountryOrRegion',
  wrongPassword: 'wrongPassword',
  success: 'success',
  roomOffline: 'roomOffline',
};
